module.exports = __webpack_public_path__ + "static/media/signin-bg.8a668c11.png";